<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* font styling */
@font-face {
  font-family: "gotham";
  src: url("./fonts/Gotham-Book.otf");
}

@font-face {
  font-family: "gothamLight";
  src: url("./fonts/Gotham-Light.otf");
}

@font-face {
  font-family: "gothamThin";
  src: url("./fonts/Gotham-Thin.otf");
}

@font-face {
  font-family: "gothamMedium";
  src: url("./fonts/Gotham-Medium.otf");
}

@font-face {
  font-family: "gothamUltra";
  src: url("./fonts/Gotham-Ultra.otf");
}

@font-face {
  font-family: "gothamNarrowBlack";
  src: url("./fonts/GothamNarrow-Black.otf");
}

:root {
  --orange: #f26526;
  --blue: #059ca6;
  --black: #000000;
  --grey: rgba(0, 0, 0, 0.4);
  --gotham: "gothamLight", sans-serif;
  --gothamBold: "gotham", sans-serif;
  --gothamMedium: "gothamMedium", sans-serif;
  --deep-grey: rgba(15, 61, 71, 0.9);
  --deeper-grey: #0f3d47;
  --light-grey: #e5e5e5;
}

body {
  font-family: var(--gotham);
}
</style>
